@if (report) {
	<div>
		<div>
			<span class="icon">
				<nz-icon nzType="home" nzTheme="outline" />
			</span>
			<span class="title">Schools</span>
			<span class="number">{{ report.summary.totalSchools | number }}</span>
		</div>
		<div>
			<span class="icon">
				<nz-icon nzType="home" nzTheme="outline" />
			</span>
			<span class="title">Classes</span>
			<span class="number">{{ report.summary.totalSections | number }}</span>
		</div>
		<div>
			<span class="icon">
				<nz-icon nzType="user" nzTheme="outline" />
			</span>
			<span class="title">Teachers</span>
			<span class="number">{{ report.summary.totalTeachers | number }}</span>
		</div>
		<div>
			<span class="icon">
				<nz-icon nzType="user" nzTheme="outline" />
			</span>
			<span class="title">Students</span>
			<span class="number">{{ report.summary.totalStudents | number }}</span>
		</div>
	</div>
}
